import * as React from 'react'
import ExclusiveLabel from './ExclusiveLabel'
import HighlightLabel from './HighlightLabel'
import NeutralLabel from './NeutralLabel'

type Variant = 'standard' | 'premium' | 'promotion' | 'exclusive'

const highlightVariants = new Set<Variant>(['premium', 'promotion'])

type InheritedLabelProps = Pick<
  React.ComponentProps<typeof HighlightLabel>,
  'format' | 'startIcon' | 'endIcon'
>

interface Props extends InheritedLabelProps {
  children: React.ReactNode
  variant: Variant
  className?: string
}

function StructureLabel(props: Props) {
  const { variant, ...rest } = props

  if (variant === 'exclusive') {
    return <ExclusiveLabel {...rest} />
  }

  const LabelComponent = highlightVariants.has(variant)
    ? HighlightLabel
    : NeutralLabel

  return <LabelComponent {...rest} />
}

export default StructureLabel
